// extracted by mini-css-extract-plugin
export default {"icon":"icon_icon__DlL6D","svg":"icon_svg__YryX4"};